module.exports = __webpack_public_path__ + "img/grey_040.094b25f4.png";